import React, { ComponentProps, PropsWithChildren } from 'react';
import { Tabs as AntTabs } from 'antd';

import { Colors } from '@common/tokens';
import { Tab } from './_tab';
import { Pane } from './_pane';

type AntdTabProps = ComponentProps<typeof AntTabs> & {
  containerStyle?: React.CSSProperties;
};

export const Tabs = ({
  children,
  containerStyle,
  ...props
}: PropsWithChildren<AntdTabProps>) => (
  <div className="wk-tabs" style={containerStyle}>
    <AntTabs tabBarGutter={20} {...props}>
      {children}
    </AntTabs>
    <style jsx>{`
      .wk-tabs {
        height: 100%;
      }
      .wk-tabs :global(.ant-tabs-tab) {
        color: ${Colors.elm};
        padding-bottom: 14px;
        transition: color 0.5s;
        text-align: center;
        font-weight: 900;
        text-transform: uppercase;
        font-style: normal;
        line-height: 20px;
      }

      .wk-tabs :global(.ant-tabs-tab:hover),
      .wk-tabs :global(.ant-tabs-tab-active) {
        color: ${Colors.elmDarker};
      }

      .wk-tabs :global(.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn) {
        text-shadow: none;
      }

      .wk-tabs :global(.ant-tabs-ink-bar) {
        height: 4px;
      }

      .wk-tabs :global(.ant-tabs-nav) {
        border-bottom: none;
        box-shadow: inset 0 -4px 0 rgba(223, 239, 242);
        margin-bottom: 0;
      }
      {/* fix: redundant gutter */}
      .wk-tabs :global(.ant-tabs-tab + .ant-tabs-tab) {
        margin: 0;
      }
    `}</style>
  </div>
);

Tabs.Pane = Pane;
Tabs.Tab = Tab;
